var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 16,
    viewBox: "0 0 51 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.7562H0.987779L6.27065 3.93282L11.571 14.7562H12.5588L6.27082 2L0 14.7562Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5586 14.7563H25.5464L30.8293 3.93298L36.1296 14.7563H37.1174L30.8291 2.00016L24.5586 14.7563Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7378 2.00016H22.75L18.6834 7.42771L14.6236 2.00016H13.6358L18.1073 8.13178L13.2924 14.757H14.2801L18.6741 8.91255L23.068 14.757H24.0558L19.2683 8.13178L23.7378 2.00016Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3533 2.00016C43.0834 2.00019 41.842 2.3768 40.7861 3.08236C39.7302 3.78792 38.9072 4.79075 38.4212 5.96402C37.9353 7.1373 37.8081 8.42834 38.0559 9.67388C38.3037 10.9194 38.9152 12.0635 39.8132 12.9615C40.7112 13.8595 41.8553 14.471 43.1008 14.7188C44.3463 14.9665 45.6374 14.8394 46.8106 14.3534C47.9839 13.8675 48.9868 13.0445 49.6923 11.9886C50.3979 10.9327 50.7745 9.69127 50.7745 8.42133C50.7745 7.57808 50.6085 6.74309 50.2858 5.96402C49.9631 5.18496 49.4901 4.47709 48.8939 3.88082C48.2976 3.28455 47.5897 2.81158 46.8106 2.4889C46.0316 2.16621 45.1966 2.00014 44.3533 2.00016ZM44.3415 13.9555C43.2446 13.9554 42.1724 13.6302 41.2604 13.0207C40.3484 12.4113 39.6376 11.5452 39.2178 10.5318C38.7981 9.51838 38.6883 8.40328 38.9023 7.32747C39.1163 6.25167 39.6445 5.26349 40.4201 4.48788C41.1957 3.71227 42.1839 3.18407 43.2597 2.97007C44.3355 2.75607 45.4506 2.86588 46.464 3.28563C47.4773 3.70537 48.3435 4.41619 48.9529 5.32819C49.5623 6.2402 49.8876 7.31244 49.8877 8.40932C49.8875 9.88012 49.3032 11.2906 48.2631 12.3306C47.223 13.3706 45.8123 13.9555 44.3415 13.9555Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxao);
export default __webpack_public_path__ + "static/media/AXAO.96e1eb173a7c32815de2e397aeb4cfdb.svg";
export { ForwardRef as ReactComponent };